var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 57,
    viewBox: "0 0 71 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ticket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M41.5882 2.99023V10.9561",
    stroke: "#B067FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M41.5882 47.4598V54.1222",
    stroke: "#B067FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M41.5882 36.1517V20.2826",
    stroke: "#B067FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5611 54.8333C63.5587 54.8333 68.4166 50.0359 68.4166 44.1128V35.5791C64.4479 35.5791 61.2517 32.4227 61.2517 28.5034C61.2517 24.584 64.4479 21.4242 68.4166 21.4242L68.4132 12.8871C68.4132 6.96406 63.5519 2.16663 57.5577 2.16663H13.4422C7.44797 2.16663 2.58669 6.96406 2.58669 12.8871L2.58325 21.7022C6.55193 21.7022 9.74816 24.584 9.74816 28.5034C9.74816 32.4227 6.55193 35.5791 2.58325 35.5791V44.1128C2.58325 50.0359 7.4411 54.8333 13.4388 54.8333H57.5611Z",
    stroke: "#B067FE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticketIcon.32f8148181f442448140a7da5ac70a43.svg";
export { ForwardRef as ReactComponent };